export default __webpack_public_path__ + "static/media/flaticon.3df97e10.webp";